var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"logo"},[_c('h1',[_c('router-link',{attrs:{"to":{name: 'CountryList'}}},[_vm._v("Where in the world?")])],1)]),_c('theme-switcher')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }